export default __webpack_public_path__ + "static/media/koreadailylogo.0087d0b0.jpg";